import React from 'react'

import { Heading4, Body3, Strong, Space } from '@gousto-internal/citrus-react'
import Immutable from 'immutable'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { getNumPortions } from 'selectors/basket'

import { SubIngredients } from '../SubIngredients/SubIngredients'

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export const IngredientsList = ({ ingredients, allergens }) => {
  const numPortion = useSelector(getNumPortions)

  return (
    <div>
      {ingredients.size > 0 ? (
        <>
          <Heading4>Ingredients contain</Heading4>
          <Space size={4} />
          {ingredients.toArray().map((ingredient) => {
            const subIngredients = ingredient.get('subIngredients')

            const name = ingredient.get('name')
            const quantity = ingredient.getIn(['quantities', `for${numPortion}`, 'in_meal'])

            if (!subIngredients || quantity <= 0) {
              return <span key={name} />
            }

            return (
              <dl key={name} data-testid="ingredient">
                <Body3>
                  <Strong>{capitalizeFirstLetter(name)}: </Strong>
                  <SubIngredients subIngredients={subIngredients} allergens={allergens} />
                </Body3>
              </dl>
            )
          })}
        </>
      ) : (
        <span />
      )}
    </div>
  )
}

IngredientsList.propTypes = {
  ingredients: PropTypes.instanceOf(Immutable.List).isRequired,
  allergens: PropTypes.instanceOf(Immutable.List).isRequired,
}
